export class StoreItemFileUpload {
     files: Array<File>;
     requestId: number;
}
